import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--color-text-dark)] text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Northbridge HVAC Inc.</h3>
            <p className="text-gray-300 mb-4">
              Keeping York Region homes comfortable since 2018. Licensed gas technicians, transparent pricing, and we don't leave a mess.
            </p>
            <p className="text-sm text-gray-400">
              TSSA Gas Technician 2 License #DEMO-0000<br />
              WSIB Clearance • $5M Liability Insurance
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Info</h3>
            <div className="space-y-3 text-gray-300">
              <a href="tel:9055550142" className="flex items-center gap-2 hover:text-[var(--color-warm-amber)]">
                <Phone size={16} />
                <span>(905) 555-0142</span>
              </a>
              <div className="flex items-center gap-2">
                <Mail size={16} />
                <span>service@northbridgehvac.ca</span>
              </div>
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>Serving York Region & North Toronto</span>
              </div>
              <div className="flex items-start gap-2">
                <Clock size={16} className="mt-1 flex-shrink-0" />
                <div>
                  <p>Mon-Fri: 7:30 AM - 6:00 PM</p>
                  <p>Sat: 8:00 AM - 4:00 PM</p>
                  <p>Sun: Emergency service only</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <nav aria-label="Footer navigation">
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link to="/services" className="hover:text-[var(--color-warm-amber)]">
                    Our Services
                  </Link>
                </li>
                <li>
                  <Link to="/service-area" className="hover:text-[var(--color-warm-amber)]">
                    Service Area
                  </Link>
                </li>
                <li>
                  <Link to="/summer-ac-tune-up" className="hover:text-[var(--color-warm-amber)]">
                    AC Tune-Up Special
                  </Link>
                </li>
                <li>
                  <Link to="/furnace-inspection" className="hover:text-[var(--color-warm-amber)]">
                    Furnace Inspection
                  </Link>
                </li>
                <li>
                  <Link to="/accessibility" className="hover:text-[var(--color-warm-amber)]">
                    Accessibility
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-[var(--color-warm-amber)]">
                    Book Service Call
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="text-center space-y-2">
            <p className="text-sm text-gray-400">
              © {currentYear} Northbridge HVAC Inc. All rights reserved.
            </p>
            <div className="bg-gray-800 px-4 py-3 rounded-lg">
              <p className="text-sm text-gray-300 italic">
                This is a portfolio demonstration site by [Platform Name]. The business shown is fictional and is not a live commercial entity. No services are sold from this site.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}